import React from "react";
import { Link } from "react-router";
import styles from "./HeaderDropdown.module.scss";

interface IContent {
  id: number;
  text: string;
  link?: string;
}

interface IExtraContent {
  id: number;
  extraTitle: string;
  content: IContent[];
}

interface DropdownProps {
  title: string;
  content?: IContent[];
  extraContent?: IExtraContent[];
}

const HeaderDropdown: React.FC<DropdownProps> = ({ title, content, extraContent }) => {
  const [isMenuActive, setIsMenuActive] = React.useState(false);
  const isContentArray = Array.isArray(content);

  const [activeExtraMenuIndexes, setActiveExtraMenuIndexes] = React.useState<number[]>([]);

  const toggleExtraMenu = (id: number) => {
    setActiveExtraMenuIndexes((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };


  const isExtraContentArray = Array.isArray(extraContent);

  return (
    <div className={isMenuActive ? `${styles.dropdown} ${styles.active}` : styles.dropdown}>
      <div
        className={styles.title}
        onClick={() => {
          setIsMenuActive(!isMenuActive);

          if (isMenuActive) {
            setActiveExtraMenuIndexes([]);
          }
        }}
      >
        <p>{title}</p>
        <svg width="8" height="22" viewBox="0 0 36 64" fill="currentColor">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.57071 63.0644C2.86644 64.3116 4.96415 64.3116 6.25655 63.0644L33.6589 36.6222C36.247 34.1247 36.247 30.0729 33.6589 27.5754L6.05773 0.9363C4.77526 -0.2981 2.70408 -0.314912 1.40504 0.903488C0.0794952 2.14746 0.0629511 4.19813 1.36862 5.4613L26.6302 29.8363C27.9259 31.0867 27.9259 33.1109 26.6302 34.3613L1.57071 58.5425C0.274993 59.7897 0.274993 61.8173 1.57071 63.0644Z"
            fill="#000"
          />
        </svg>
      </div>

      <ul className={styles.content}>
        {isContentArray &&
          content.map((item) => (
            <li key={item.id}>
              {item.link ? (

                <Link to={item.link} className={styles.link}>
                  {item.text}
                </Link>
              ) : (
                <p>{item.text}</p>
              )}
            </li>
          ))}
      </ul>

      {isMenuActive &&
        extraContent?.map((item) => {
          const isActive = activeExtraMenuIndexes.includes(item.id);
          return (
            <div key={item.id} className={isActive ? `${styles.extraDropdown} ${styles.active}` : styles.extraDropdown}>
              <div className={styles.extraTitle} onClick={() => toggleExtraMenu(item.id)}>
                <p>{item.extraTitle}</p>
                <svg width="8" height="22" viewBox="0 0 36 64" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.57071 63.0644C2.86644 64.3116 4.96415 64.3116 6.25655 63.0644L33.6589 36.6222C36.247 34.1247 36.247 30.0729 33.6589 27.5754L6.05773 0.9363C4.77526 -0.2981 2.70408 -0.314912 1.40504 0.903488C0.0794952 2.14746 0.0629511 4.19813 1.36862 5.4613L26.6302 29.8363C27.9259 31.0867 27.9259 33.1109 26.6302 34.3613L1.57071 58.5425C0.274993 59.7897 0.274993 61.8173 1.57071 63.0644Z"
                    fill="#000"
                  />
                </svg>
              </div>

              {isActive && (
                <ul className={styles.extraContent}>
                  {item.content.map((extraItem) => (
                    <li key={extraItem.id}>
                      {extraItem.link ? (
                        <Link to={extraItem.link} className={styles.link}>
                          {extraItem.text}
                        </Link>
                      ) : (

                        <p>{extraItem.text}</p>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default HeaderDropdown;
